import { TTS_EMOTIONS } from '@/app/constants';

export const TTS_LIMITS = {
  MAX_TEXT_LENGTH: 5000,
  MIN_PAUSE: 0.01,
  MAX_PAUSE: 99.99,
} as const;

const EMOTION_TAG_REGEX = /\{\/?[^{}]+\}/g;

export function getTtsTextLength(value: string): number {
  let count = 0;
  const textWithoutEmotionTags = value.replace(EMOTION_TAG_REGEX, '');

  for (const char of textWithoutEmotionTags) {
    const code = char.charCodeAt(0);
    if (code >= 0x4e00 && code <= 0x9fff) {
      count += 2;
      continue;
    }
    count += 1;
  }

  return count;
}

export const TTS_CARET_ANCHOR = '\u200B';

export const PAUSE_PRESETS = [0.25, 0.5, 1, 1.5] as const;

const PAUSE_TAG_PATTERN = String.raw`<#(\d+(?:\.\d{1,2})?)#>`;

export const PAUSE_REGEX = new RegExp(PAUSE_TAG_PATTERN, 'g');
export const PAUSE_START_REGEX = new RegExp(`^${PAUSE_TAG_PATTERN}`);
export const PAUSE_SINGLE_REGEX = new RegExp(PAUSE_TAG_PATTERN);

// Build emotion regex dynamically from TTS_EMOTIONS ids
// Matches patterns like {happy}text{/happy}
export const buildEmotionRegex = () => {
  const ids = TTS_EMOTIONS.map((e) => e.id).join('|');
  return new RegExp(`\\{(${ids})\\}([^{]*?)\\{/\\1\\}`, 'g');
};

export const TTS_SPEED = {
  MIN: 0.5,
  MAX: 2,
  STEP: 0.1,
  DEFAULT: 1.0,
} as const;

export const TTS_PITCH = {
  MIN: -12,
  MAX: 12,
  STEP: 1,
  DEFAULT: 0,
} as const;

export const TTS_VOLUME = {
  MIN: 0,
  MAX: 10,
  STEP: 1,
  DEFAULT: 0,
} as const;
